// External imports
import NextLink from "next/link";

// Local imports
import classes from "./style.module.css";

// Component props for DownloadLink
interface Props {
  downloadPath: string;
}

export default function DownloadLink({ downloadPath }: Props) {
  return (
    <NextLink href={`${downloadPath}`} download className={`${classes.link}`}>
      Download Font
    </NextLink>
  );
}
